import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "icon-wrapper warning" }
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "footer" }

import { Modal, Button, Icon } from "@/components/ui";


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkedInWarningModal',
  props: {
    show: { type: Boolean },
    estimatedContacts: {},
    loading: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    show: __props.show,
    size: "sm",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Icon), {
            icon: "mdi:alert",
            class: "icon warning-icon"
          })
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "title" }, "Large Contact List Detected", -1))
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(Button), {
          variant: "secondary",
          size: "md",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode(" Cancel ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          variant: "primary",
          size: "md",
          loading: __props.loading,
          disabled: __props.loading,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode(" Continue ", -1)
          ]))]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _cache[4] || (_cache[4] = _createTextVNode(" You are about to search for ", -1)),
          _createElementVNode("strong", null, _toDisplayString(__props.estimatedContacts) + " contacts", 1),
          _cache[5] || (_cache[5] = _createTextVNode(" from your LinkedIn Sales Navigator search. This may take a while to process. ", -1))
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("p", {
          class: "text",
          style: {"margin-top":"12px"}
        }, "Are you sure you want to continue?", -1))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})